import { useState, useEffect, ChangeEvent, FocusEvent, ComponentProps } from 'react';
import { Input } from '@easyflow/ui-master/components/ui/input';

type BaseInputProps = ComponentProps<typeof Input>;

export interface UppercaseInputProps
  extends Omit<BaseInputProps, 'onChange' | 'value'> {
  value: string | null | undefined;
  onChange: (next: string) => void;
}

/**
 * Wrapper di shadcn Input che on blur normalizza il valore in
 * UPPERCASE (toLocaleUpperCase('it-IT')). Durante la digitazione lascia
 * passare il testo così com'è e propaga ogni keystroke; al blur, se il
 * valore differisce dalla versione uppercase, ri-emette onChange con il
 * valore normalizzato. Backend valida con la stessa transform Zod
 * (Task #1503): l'UI è feedback visivo, non gate.
 */
export function UppercaseInput({ value, onChange, onBlur, ...rest }: UppercaseInputProps) {
  const [local, setLocal] = useState<string>(value ?? '');

  useEffect(() => {
    setLocal(value ?? '');
  }, [value]);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setLocal(e.target.value);
    onChange(e.target.value);
  };

  const handleBlur = (e: FocusEvent<HTMLInputElement>) => {
    const upper = (local ?? '').toLocaleUpperCase('it-IT');
    if (upper !== local) {
      setLocal(upper);
      onChange(upper);
    }
    onBlur?.(e);
  };

  return <Input {...rest} value={local} onChange={handleChange} onBlur={handleBlur} />;
}

export default UppercaseInput;
